import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import { FaSearch } from "react-icons/fa";
import Background from './Background';
import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

function Careers() {

    const [cookies, setCookie] = useCookies(['user']);
    const [careers, setCareers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [editingCareer, setEditingCareer] = useState(null);
    const [editForm, setEditForm] = useState({ title: '', company: '', last_date_to_apply: '', experience: '', type: '', description: '', active: 1 });

    const getCareers = () => {
        var data = new FormData();
        
        data.append("user_id", cookies.id ?? '');
        setIsLoading(true);
        fetch('https://api.connecker.com/api/get_careers', {
            method: 'POST',
            body: data
        }).then(res => {
            setIsLoading(false);
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
         }).then(data => {
            setIsLoading(false);
            if(data.response_code == 200) {
               setCareers(data.data);
            } else if(data.response_code == 404) {
                setCareers([]);
            }
         });
    }

    const deleteCareerAPI = (career_id) => {
        var data = new FormData();
        
        data.append("career_id",career_id);
        setIsLoading(true);
        fetch('https://api.connecker.com/api/delete_career', {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': `Bearer ${cookies.token}`
            }
        }).then(res => {
            setIsLoading(false);
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
         }).then(data => {
            setIsLoading(false);
            if(data.response_code == 200) {
                toast(data.message);
                getCareers();
            } else if(data.response_code == 404) {
                toast(data.message);
            }
         });
    }

    const deleteCareer = (career_id) => {
        // Display a confirmation dialog
        const result = window.confirm('Are you sure you want to proceed?');
    
        // Check the result of the confirmation dialog
        if (result) {
        // User clicked OK, proceed with the action
        deleteCareerAPI(career_id);
        } else {
        // User clicked Cancel, do nothing or handle accordingly
        console.log('User canceled');
        }
    }

    const openEditModal = (career) => {
        setEditingCareer(career);
        setEditForm({
            title: career.title || '',
            company: career.company || '',
            last_date_to_apply: career.last_date_to_apply ? career.last_date_to_apply.split('T')[0] : '',
            experience: career.experience || '',
            type: career.type || '',
            description: career.description || '',
            active: career.active !== undefined ? Number(career.active) : 1
        });
    };

    const closeEditModal = () => {
        setEditingCareer(null);
    };

    const handleEditFormChange = (field, value) => {
        setEditForm(prev => ({ ...prev, [field]: value }));
    };

    const editCareerAPI = (e) => {
        e.preventDefault();
        if (!editingCareer) return;
        var data = new FormData();
        data.append("career_id", String(editingCareer.id));
        data.append("title", editForm.title);
        data.append("company", editForm.company);
        data.append("last_date_to_apply", editForm.last_date_to_apply);
        data.append("experience", editForm.experience);
        data.append("type", editForm.type);
        data.append("description", editForm.description);
        data.append("active", String(editForm.active));
        data.append("editor_user_id", cookies.id ?? '');
        if (editingCareer.user_id) {
            data.append("user_id", String(editingCareer.user_id));
        }
        setIsLoading(true);
        fetch('https://api.connecker.com/api/edit_career', {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': `Bearer ${cookies.token}`
            }
        }).then(res => res.json()).then(data => {
            setIsLoading(false);
            if (data.response_code === 200) {
                toast.success(data.message);
                closeEditModal();
                getCareers();
            } else {
                toast.error(data.message || 'Failed to update career');
            }
        }).catch(() => {
            setIsLoading(false);
            toast.error('Failed to update career');
        });
    };

    useEffect(() => {
        const abortController = new AbortController();
        getCareers();
       },[]);

    return(
        <div className="content">
            <div className="row justify-content-start">
                <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10" style={{ paddingLeft: "40px" }}>
                    <Background></Background>
                    <h4 className="heading" style={{ color:"white", marginTop:"50px" }}>Careers</h4>
                    
                    {/* Table */}
                    <div className="card" style={{ borderColor:"white" }}>
                        <div className="table-responsive">
                            <table style={{ width:"100%" }} className="table table-striped">
                                <thead style={{ backgroundColor: "#f8f9fa" }}>
                                    <tr style={{ borderBottom: "2px solid #dee2e6" }}>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>#</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>TITLE</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>COMPANY</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>LAST DATE TO APPLY</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>EXPERIENCE</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>TYPE</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>DESCRIPTION</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>STATUS</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>ACTIONS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        careers.map((career, i) => (
                                                <tr key={career.id} style={{ borderBottom: "1px solid #eee" }}>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        {i+1}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333", fontWeight: "500" }}>
                                                        {career.title}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#666" }}>
                                                        {career.company || '-'}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#666" }}>
                                                        {career.last_date_to_apply ? new Date(career.last_date_to_apply).toLocaleDateString() : '-'}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#666" }}>
                                                        {career.experience}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        <span style={{
                                                            padding: "4px 12px",
                                                            backgroundColor: "#e9ecef",
                                                            borderRadius: "12px",
                                                            color: "#495057",
                                                            fontSize: "12px",
                                                            fontWeight: "500",
                                                            display: "inline-block",
                                                            textAlign: "center"
                                                        }}>
                                                            {career.type}
                                                        </span>
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#666", maxWidth: "300px" }}>
                                                        {career.description && career.description.length > 100 ? 
                                                            career.description.substring(0, 100) + '...' : 
                                                            career.description
                                                        }
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        <span style={{
                                                            padding: "4px 12px",
                                                            backgroundColor: Number(career.active) === 1 ? "#d4edda" : "#f8d7da",
                                                            borderRadius: "12px",
                                                            color: Number(career.active) === 1 ? "#155724" : "#721c24",
                                                            fontSize: "12px",
                                                            fontWeight: "500",
                                                            display: "inline-block",
                                                            textAlign: "center"
                                                        }}>
                                                            {Number(career.active) === 1 ? "Active" : "Inactive"}
                                                        </span>
                                                    </td>
                                                    <td style={{ padding: "12px 8px" }}>
                                                        <button 
                                                            className="btn btn-sm me-1"
                                                            onClick={() => openEditModal(career)}
                                                            style={{
                                                                backgroundColor: "#0d6efd",
                                                                borderColor: "#0d6efd",
                                                                color: "white",
                                                                fontSize: "12px",
                                                                padding: "6px 12px",
                                                                borderRadius: "6px"
                                                            }}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm"
                                                            onClick={() => deleteCareer(career.id)}
                                                            style={{
                                                                backgroundColor: "#dc3545",
                                                                borderColor: "#dc3545",
                                                                color: "white",
                                                                fontSize: "12px",
                                                                padding: "6px 12px",
                                                                borderRadius: "6px"
                                                            }}
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Career Modal */}
            {editingCareer && (
                <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Career</h5>
                                <button type="button" className="btn-close" onClick={closeEditModal} aria-label="Close"></button>
                            </div>
                            <form onSubmit={editCareerAPI}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editForm.title}
                                            onChange={(e) => handleEditFormChange('title', e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Company</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editForm.company}
                                            onChange={(e) => handleEditFormChange('company', e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Last Date to Apply</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={editForm.last_date_to_apply}
                                            onChange={(e) => handleEditFormChange('last_date_to_apply', e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Experience</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editForm.experience}
                                            onChange={(e) => handleEditFormChange('experience', e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Type</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editForm.type}
                                            onChange={(e) => handleEditFormChange('type', e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Description</label>
                                        <textarea
                                            className="form-control"
                                            rows={4}
                                            value={editForm.description}
                                            onChange={(e) => handleEditFormChange('description', e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Active</label>
                                        <select
                                            className="form-select"
                                            value={editForm.active}
                                            onChange={(e) => handleEditFormChange('active', Number(e.target.value))}
                                        >
                                            <option value={1}>Active</option>
                                            <option value={0}>Inactive</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closeEditModal}>Cancel</button>
                                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                        {isLoading ? 'Saving...' : 'Save changes'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <ToastContainer />
        </div>
    )
}

export default Careers;